var map = {
	"./node-vinyl.js": "./src/importers/node-vinyl.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 141;



//////////////////
// WEBPACK FOOTER
// ./src/importers nonrecursive .js$
// module id = 141
// module chunks = 0